import React from "react"
import {
  Modal,
} from "../ui_new"
import { CheckCircle, Close } from "../../assets/icons"
import { Cancel } from "@mui/icons-material"

const ValidationSuggestionModal = ({
  onClose,
  onConfirm = () => { throw new Error('onConfirm function not provided') },
  onCancel = () => { throw new Error('onCancel function not provided') },
}) => {
  
  const handleCancel = () => {
    onCancel()
    // onClose()
  }

  const handleConfirm = () => {
    onConfirm()
    // onClose()
  }

  const title = 'Proposition de modification'

  const descriptionText = 'Vous êtes sur le point de proposer une modification'

  const questionText = 'Êtes-vous sûr de vouloir continuer ?'


  const hintText = ''

  const cancelLabel = 'Annuler'

  const confirmLabel = 'Valider'

  const secondaryButtonLabel = ''

  return (
    <Modal onClose={onClose} className="modal-v2--medium">
      <div className="modal-v2__heading modal-v2__heading--light modal-v2__heading--small">
        <h2>{title}</h2>
        <div className="buttons-row">
          <button
            className="btn btn--small btn--light btn--border-primary btn--border-radius-sm btn--square"
            onClick={onClose}
          >
            <Close />
          </button>
        </div>
      </div>
      <div className="document-share__body">
        <div>
        {descriptionText && <p className="share-warning--text">{descriptionText}</p>}
          {questionText && <p className="share-warning--question">{questionText}</p>}
          {hintText && <p className="share-warning--hint">{hintText}</p>}
        </div>
        <div className="modal-v2__buttons-footer">
          {cancelLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-danger"
              onClick={handleCancel}
            >
              <Close fontSize="small" />
              {cancelLabel}
            </button>
          )}
          {confirmLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-success"
              onClick={handleConfirm}
            >
              <CheckCircle />
              {confirmLabel}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ValidationSuggestionModal
